import Footer from "./Footer";
import { useEffect, useState } from "react";
import { webPaths } from "../routes/pageRoutes";
import { buildAuthModalState } from "../routes/authModal";
import { useLocation, useNavigate } from "react-router-dom";
import MobileAppModal from "../components/modal/MobileAppModal";
import {
  SECURPOINT_APP_STORE_URL,
  SECURPOINT_PLAY_STORE_URL,
} from "../utils/mobileAppLinks";
import CategoryDropdown from "../components/CategoryDropdown";

const WebLayout = ({
  children,
  categoryId = "",
  searchFilter = "",
  assetCategoryList = [],
  onCategoryChange,
  onSearchChange,
  onSearch,
  onClearSearch,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScroll(window.scrollY >= 425);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <di style={{ height: "90px" }}>
        <header
          class={`ct_header ${scroll && pathname == webPaths?.WebHome ? "ct_active_sticky" : ""}`}
        >
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-12">
                <nav class="ct_navbar">
                  <div class="ct_logo">
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        navigate(webPaths?.WebHome);
                      }}
                    >
                      <img src="/assets/img/logo_black.png" alt="" />
                    </a>
                  </div>

                  <div className={`ct_search_sticky_main`}>
                    <CategoryDropdown
                      value={categoryId}
                      options={assetCategoryList}
                      onChange={onCategoryChange}
                      className="ct_select_w_177 ct_w_100_575"
                      buttonClassName="ct_input opacity-75"
                      style={{
                        boxShadow: "0px 0px 9px 0px #00000040",
                        height: "50px",
                      }}
                    />
                    <div class="position-relative ct_search">
                    <input
                      type="text"
                      value={searchFilter}
                      onChange={(e) => onSearchChange?.(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            onSearch?.();
                          }
                        }}
                        class="form-control ct_input"
                      style={{
                        boxShadow: "0px 0px 9px 0px #00000040",
                        height: "60px",
                        paddingRight: "90px",
                      }}
                      placeholder="Search assets"
                    />
                    {/* <i class="fa-solid fa-search ct_input_icon_left"></i> */}
                    <button
                      type="button"
                      className="text-white border-0 rounded bg-danger ct_show_eye px-3 py-2"
                      style={{ right: "10px" }}
                      onClick={() => {
                        onClearSearch?.();
                        onSearchChange?.("");
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>

                  <div class="ct_right_menu_items">
                    <div className="ct_right_dropdown dropdown">
                      <a
                        target="_blank"
                        class="text-dark ct_white_nowrap"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        Download the App{" "}
                        <i class="fa-solid fa-angle-down ms-1"></i>
                      </a>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton1"
                      >
                        <li>
                          <a
                            class="dropdown-item"
                            href={SECURPOINT_PLAY_STORE_URL}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              alt=""
                              src="/assets/img/play_stor_clr.png"
                              style={{ width: "20px" }}
                            />{" "}
                            Play Store
                          </a>
                        </li>
                        <li>
                          <a
                            class="dropdown-item"
                            href={SECURPOINT_APP_STORE_URL}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              alt=""
                              src="/assets/img/apple_icon.png"
                              style={{ width: "20px" }}
                            />{" "}
                            App Store
                          </a>
                        </li>
                      </ul>
                    </div>
                    {/* <a href="# " class="ct_green_bnt ct_white_nowrap">Log In</a> */}
                    <button
                      class="ct_green_bnt ct_white_nowrap ct_outline_login_btn"
                      // data-bs-toggle="modal"
                      // data-bs-target="#SignUpModal"
                      onClick={() => {
                        navigate(webPaths?.Login, {
                          state: buildAuthModalState(location),
                        });
                      }}
                    >
                      <svg
                        className="me-2"
                        viewBox="0 0 200 200"
                        width="1.25em"
                        height="1.25em"
                        xmlns="http://www.w3.org/2000/svg"
                        role="presentation"
                        aria-hidden="true"
                      >
                        <path d="M180 155.435V177.5H20v-22.064c50.314-24.61 110.67-24.128 160-.001zm-80-36.132c17.673 0 32-14.446 32-32.267V54.768c0-17.821-14.327-32.268-32-32.268S68 36.946 68 54.768v32.268c0 17.82 14.327 32.267 32 32.267z"></path>
                      </svg>{" "}
                      Sign in
                    </button>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </header>
      </di>
      {children}

      <Footer />
      <MobileAppModal />
      <div className="ct_fixed_button_top">
        <button
          class="ct_green_bnt ct_white_nowrap  px-3 ct_border_radius_15 ct_green_btn_after_15_radius"
          data-bs-target="#mobileAppModal"
          data-bs-toggle="modal"
        >
          <i class="fa-solid fa-plus me-2"></i>Add Assets
        </button>
      </div>
    </>
  );
};

export default WebLayout;
